import * as clientService from "../services/httpsClient";

export const getSummaryReport = async (accessToken, params) => {
  try {
    return await clientService.getApi(`summaryreport`, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const exportExcelSummaryReport = async (accessToken, params) => {
  try {
    return await clientService.exportExcelZip(`summaryreport/export-excel`, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const getSummaryReportDetail = async (accessToken, params) => {
  try {
    return await clientService.getApi(`summaryreport/detail`, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const exportExcelSummaryReportDetail = async (accessToken, params) => {
  try {
    return await clientService.exportExcelZip(`summaryreport/export-excel-detail`, accessToken, params);
  } catch (error) {
    throw error;
  }
};
